import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import shortid from "shortid";
import Button from "@mui/material/Button";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import useHttp from "../../../../hooks/useHttp";
import {
  UPDATE_PROFILE_URL,
  SHIPPER_PROFILE_URL,
  CARRIER_PROFILE_URL,
  COUNTRY_STATE_N_CITY_LIST_URL,
} from "../../../../utils/api-ends";
import avatar from "../../../../assets/media/avatar.png";
import { SpinnerCircular } from "spinners-react";
import { progressing_status } from "../../../../store/slices/progessingRequest";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Modal from "@mui/material/Modal";

const ProfileInformation = () => {
  const { error, isLoading, sendRequests } = useHttp();
  const userData = useSelector((state) => state.basicInfo.userDetails);
  const dispatch = useDispatch();

  const [allValues, setAllValues] = useState({
    email: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    country: "",
    state: "",
    city: "",
    zip_code: "",
    street_address: "",
    bank_name: "",
    bank_account_number: "",
    bank_account_holder_name: "",
    bank_account_branch_name: "",
    bank_account_country: "",
    company_name: "",
    license_number: "",
    bonding_agent: "",
    bonding_co_phone_number: "",
    profile_url: "",
    profile_file: [],
    load_type: "",
    carrier_type: "",
    icc_mc_number: "",
    cargo_insurance_company: "",
    vehicle_image_url: "",
    cargo_Inc_limit: "",
    liability_Inc_limit: "",
    cargo_Inc_agent: "",
    vehicle_image: "",
    agent_phone: "",
    Inc_deductible: "",
    driving_licence: "",
    emailVerification: true,
    phoneVerification: true,
    shipper_type: "",
  });

  const [allError, setAllError] = useState({
    emailError: [],
    firstNameError: [],
    lastNameError: [],
    phoneNumberError: [],
    countryError: [],
    stateError: [],
    cityError: [],
    zipCodeError: [],
    streetAddressError: [],
    bankNameError: [],
    bankAccountNumberError: [],
    bankAccountHolderNameError: [],
    bankAccountBranchNameError: [],
    bankAccountCountryError: [],
    companyNameError: [],
    licenseNumberError: [],
    bondingAgentError: [],
    bondingCoPhoneNumberError: [],
    profileFileError: [],
    loadTypeError: [],
    carrierTypeError: [],
    iccMcNumberError: [],
    cargoInsuranceCompanyError: [],
    cargoIncLimitError: [],
    liabilityIncLimitError: [],
    cargoIncAgentError: [],
    vehicleImage: [],
    agentPhoneError: [],
    IncDeductibleError: [],
    drivingLicenceError: [],
    generalError: [],
    messageError: [],
    shipperTypeError: [],
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const navigate = useNavigate();

  const usa_phn_number = (num, user) => {
    if (user === false) return;

    if (num?.includes("+1")) {
      return num?.split("+1")[1];
    } else {
      return num;
    }
  };

  useEffect(() => {
    let url = "";
    //set url depending on user type
    if (userData?.user_type === "shipper") {
      url = SHIPPER_PROFILE_URL;
    } else {
      url = CARRIER_PROFILE_URL;
    }

    // // set user values in state
    // const response = (data) => {
    //   setAllValues({
    //     ...allValues,
    //     ["first_name"]: data.data.user_obj.first_name,
    //     ["last_name"]: data.data.user_obj.last_name,
    //     ["email"]: data.data.user_obj.email,
    //     ["phone_number"]: usa_phn_number(data?.data?.user_obj?.phone_number),
    //     ["country"]: data.data.user_obj.country,
    //     ["state"]: data.data.user_obj.state,
    //     ["city"]: data.data.user_obj.city,
    //     ["zip_code"]: data.data.user_obj.zip_code,
    //     ["street_address"]: data.data.user_obj.street_address,
    //     ["bank_name"]: data.data.user_obj.bank_name,
    //     ["bank_account_number"]: data.data.user_obj.bank_account_number,
    //     ["bank_account_holder_name"]:
    //       data.data.user_obj.bank_account_holder_name,
    //     ["bank_account_branch_name"]:
    //       data.data.user_obj.bank_account_branch_name,
    //     ["bank_account_country"]: data.data.user_obj.bank_account_country,
    //     ["company_name"]: data.data.user_obj.company_name,
    //     ["license_number"]: data.data.license_number,
    //     ["bonding_agent"]: data.data.bonding_agent,
    //     ["bonding_co_phone_number"]: usa_phn_number(
    //       data?.data?.bonding_co_phone_number,
    //       userData?.user_type === "shipper"
    //     ),
    //     ["profile_url"]: data.data.user_obj.profile_picture,
    //     ["load_type"]: data.data.load_type,
    //     ["carrier_type"]: data.data.carrier_type,
    //     ["icc_mc_number"]: data.data.icc_mc_number,
    //     ["cargo_insurance_company"]: data.data.cargo_insurance_company,
    //     ["cargo_Inc_limit"]: data.data.cargo_Inc_limit,
    //     ["liability_Inc_limit"]: data.data.liability_Inc_limit,
    //     ["cargo_Inc_agent"]: data.data.cargo_Inc_agent,
    //     ["vehicle_image_url"]: data.data.vehicle_image_url,
    //     ["agent_phone"]: usa_phn_number(
    //       data?.data?.agent_phone,
    //       userData?.user_type === "carrier"
    //     ),
    //     ["Inc_deductible"]: data.data.Inc_deductible,
    //     ["driving_licence"]: data.data.driving_licence,
    //     ["shipper_type"]: data.data.shipper_type,
    //   });
    // };


    // Helper function to map field names from the response
const mapUserData = (data) => ({
  first_name: data.data.user_obj.first_name,
  last_name: data.data.user_obj.last_name,
  email: data.data.user_obj.email,
  phone_number: usa_phn_number(data?.data?.user_obj?.phone_number),
  country: data.data.user_obj.country,
  state: data.data.user_obj.state,
  city: data.data.user_obj.city,
  zip_code: data.data.user_obj.zip_code,
  street_address: data.data.user_obj.street_address,
  bank_name: data.data.user_obj.bank_name,
  bank_account_number: data.data.user_obj.bank_account_number,
  bank_account_holder_name: data.data.user_obj.bank_account_holder_name,
  bank_account_branch_name: data.data.user_obj.bank_account_branch_name,
  bank_account_country: data.data.user_obj.bank_account_country,
  company_name: data.data.user_obj.company_name,
  license_number: data.data.license_number,
  bonding_agent: data.data.bonding_agent,
  bonding_co_phone_number: usa_phn_number(
    data?.data?.bonding_co_phone_number,
    userData?.user_type === "shipper"
  ),
  profile_url: data.data.user_obj.profile_picture,
  load_type: data.data.load_type,
  carrier_type: data.data.carrier_type,
  icc_mc_number: data.data.icc_mc_number,
  cargo_insurance_company: data.data.cargo_insurance_company,
  cargo_Inc_limit: data.data.cargo_Inc_limit,
  liability_Inc_limit: data.data.liability_Inc_limit,
  cargo_Inc_agent: data.data.cargo_Inc_agent,
  vehicle_image_url: data.data.vehicle_image_url,
  agent_phone: usa_phn_number(
    data?.data?.agent_phone,
    userData?.user_type === "carrier"
  ),
  Inc_deductible: data.data.Inc_deductible,
  driving_licence: data.data.driving_licence,
  shipper_type: data.data.shipper_type,
});

const response = (data) => {
  const userData = mapUserData(data); // Map all data fields
  setAllValues((prevValues) => ({
    ...prevValues,
    ...userData, // Merge the new mapped data into the state
  }));
};


    // Send request to get profile info
    sendRequests(
      {
        url: url,
        method: "GET",
      },
      response
    );
  }, [userData?.user_type , sendRequests]);

  // Fetch list of country
  useEffect(() => {
    const response = (data) => {
      setCountryList(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "countries",
        },
      },
      response
    );
  }, [sendRequests]);

  // Fetch list of state
  useEffect(() => {
    const response = (data) => {
      setStateList(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "states",
          country_name: allValues.country,
        },
      },
      response
    );
  }, [allValues.country, sendRequests]);

  // Fetch list of city
  useEffect(() => {
    const response = (data) => {
      setCityList(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "cities",
          country_name: allValues.country,
          state_name: allValues.state,
        },
      },
      response
    );
  }, [allValues.country, allValues.state, sendRequests]);

  // Update state values when input values change.
  const handleInputChange = (e) => {
    const inputValue =
      e.target.name === "profile_picture"
        ? {
            ...allValues,
            [e.target.name]: e.target.files[0],
            profile_url: URL.createObjectURL(e.target.files[0]),
          }
        : e.target.name === "vehicle_image"
        ? {
            ...allValues,
            [e.target.name]: e.target.files[0],
            vehicle_image_url: URL.createObjectURL(e.target.files[0]),
          }
        : e.target.name === "email"
        ? {
            ...allValues,
            [e.target.name]: e.target.value,
            emailVerification: false,
          }
        : e.target.name === "phone_number"
        ? {
            ...allValues,
            [e.target.name]: e.target.value,
            phoneVerification: false,
          }
        : { ...allValues, [e.target.name]: e.target.value };
    setAllValues(inputValue);
  };

  const handleSubmit = (e) => {
    if (isLoading) {
      return false;
    }

    e.preventDefault();
    const formData = new FormData();
    // check user type. If user type is shipper than remove carrier values from state and if user type is carrier than remove shipper values.
    if (userData?.user_type === "shipper") {
      delete allValues["load_type"];
      delete allValues["icc_mc_number"];
      delete allValues["cargo_insurance_company"];
      delete allValues["cargo_Inc_limit"];
      delete allValues["liability_Inc_limit"];
      delete allValues["cargo_Inc_agent"];
      delete allValues["agent_phone"];
      delete allValues["Inc_deductible"];
      delete allValues["driving_licence"];
      delete allValues["carrier_type"];
      delete allValues["vehicle_image"];
    } else {
      delete allValues["bonding_agent"];
      delete allValues["license_number"];
      delete allValues["bonding_co_phone_number"];
      delete allValues["shipper_type"];
    }

    //set form-data values
    for (var key in allValues) {
      if (
        ["phone_number", "bonding_co_phone_number", "agent_phone"].includes(
          key
        ) &&
        [null, undefined].includes(allValues[key])
      ) {
        allValues[key] = "";
      }

      if (
        ["phone_number", "bonding_co_phone_number", "agent_phone"].includes(
          key
        ) &&
        allValues[key]?.length > 0
      ) {
        formData.append(key, `+1${allValues[key]}`);
      } else {
        formData.append(key, allValues[key]);
      }

      console.log(key)
    }

    const response = (data) => {
      // Set success messages
      setSuccessMessage(data.message);

      // scroll to top
      window.scrollTo(0, 100);

      // Clear success messages
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);

      // Navigate to email verification or phone verification page
      setTimeout(() => {
        data.email_update === true && data.phone_number_update === true
          ? navigate("/auth/account-verification?to_verify=both")
          : data.email_update === true
          ? navigate("/auth/account-verification?to_verify=email")
          : data.phone_number_update === true
          ? navigate("/auth/account-verification?to_verify=phone")
          : navigate();
      }, 1000);
    };

    // Send request to update profile
    sendRequests(
      {
        url: UPDATE_PROFILE_URL,
        method: "PATCH",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      },
      response
    );

    // Clear error messages after submitting form data
    setAllError({
      emailError: [],
      firstNameError: [],
      lastNameError: [],
      phoneNumberError: [],
      stateError: [],
      cityError: [],
      zipCodeError: [],
      streetAddressError: [],
      bankNameError: [],
      bankAccountNumberError: [],
      bankAccountHolderNameError: [],
      bankAccountBranchNameError: [],
      bankAccountCountryError: [],
      companyNameError: [],
      licenseNumberError: [],
      bondingAgentError: [],
      bondingCoPhoneNumberError: [],
      profileFileError: [],
      loadTypeError: [],
      carrierTypeError: [],
      vehicleImage: [],
      iccMcNumberError: [],
      cargoInsuranceCompanyError: [],
      cargoIncLimitError: [],
      liabilityIncLimitError: [],
      cargoIncAgentError: [],
      agentPhoneError: [],
      IncDeductibleError: [],
      drivingLicenceError: [],
      generalError: [],
      messageError: [],
      shipperTypeError: [],
    });
  };

  // Clean error messages when click on the input
  const hideErrorMessage = (e) => {
    const attrValue = e.target.getAttribute("name");
    attrValue === "first_name"
      ? setAllError({ ...allError, firstNameError: [] })
      : attrValue === "last_name"
      ? setAllError({ ...allError, lastNameError: [] })
      : attrValue === "email"
      ? setAllError({ ...allError, emailError: [] })
      : attrValue === "phone_number"
      ? setAllError({ ...allError, phoneNumberError: [] })
      : attrValue === "state"
      ? setAllError({ ...allError, stateError: [] })
      : attrValue === "city"
      ? setAllError({ ...allError, cityError: [] })
      : attrValue === "zip_code"
      ? setAllError({ ...allError, zipCodeError: [] })
      : attrValue === "street_address"
      ? setAllError({ ...allError, streetAddressError: [] })
      : attrValue === "bank_name"
      ? setAllError({ ...allError, bankNameError: [] })
      : attrValue === "bank_account_number"
      ? setAllError({ ...allError, bankAccountNumberError: [] })
      : attrValue === "bank_account_holder_name"
      ? setAllError({ ...allError, bankAccountHolderNameError: [] })
      : attrValue === "bank_account_branch_name"
      ? setAllError({ ...allError, bankAccountBranchNameError: [] })
      : attrValue === "bank_account_country"
      ? setAllError({ ...allError, bankAccountCountryError: [] })
      : attrValue === "company_name"
      ? setAllError({ ...allError, companyNameError: [] })
      : attrValue === "cargo_Inc_limit"
      ? setAllError({ ...allError, cargoIncLimitError: [] })
      : attrValue === "liability_Inc_limit"
      ? setAllError({ ...allError, liabilityIncLimitError: [] })
      : attrValue === "agent_phone"
      ? setAllError({ ...allError, agentPhoneError: [] })
      : attrValue === "driving_licence"
      ? setAllError({ ...allError, drivingLicenceError: [] })
      : attrValue === "license_number"
      ? setAllError({ ...allError, licenseNumberError: [] })
      : attrValue === "bonding_agent"
      ? setAllError({ ...allError, vehicleImageError: [] })
      : attrValue === "vehicle_image"
      ? setAllError({ ...allError, bondingAgentError: [] })
      : attrValue === "bonding_co_phone_number"
      ? setAllError({ ...allError, bondingCoPhoneNumberError: [] })
      : attrValue === "cargo_insurance_company"
      ? setAllError({ ...allError, cargoInsuranceCompanyError: [] })
      : attrValue === "icc_mc_number"
      ? setAllError({ ...allError, iccMcNumberError: [] })
      : attrValue ==="Inc_deductible"
      ? setAllError({ ...allError, IncDeductibleError: [] })
      : attrValue === "cargo_Inc_agent"
      ? setAllError({ ...allError, cargoIncAgentError: [] })
      : setAllError({ ...allError });
  };

  useEffect(() => {
    if (error) {
      const errorFields = {
        firstNameError: error.first_name || [],
        lastNameError: error.last_name || [],
        emailError: error.email || [],
        phoneNumberError: error.phone_number || [],
        stateError: error.state || [],
        cityError: error.city || [],
        zipCodeError: error.zip_code || [],
        streetAddressError: error.street_address || [],
        bankNameError: error.bank_name || [],
        bankAccountNumberError: error.bank_account_number || [],
        bankAccountHolderNameError: error.bank_account_holder_name || [],
        bankAccountBranchNameError: error.bank_account_branch_name || [],
        bankAccountCountryError: error.bank_account_country || [],
        companyNameError: error.company_name || [],
        licenseNumberError: error.license_number || [],
        bondingAgentError: error.bonding_agent || [],
        bondingCoPhoneNumberError: error.bonding_co_phone_number || [],
        loadTypeError: error.load_type || [],
        carrierTypeError: error.carrier_type || [],
        vehicleImage: error.vehicle_image || [],
        iccMcNumberError: error.icc_mc_number || [],
        cargoInsuranceCompanyError: error.cargo_insurance_company || [],
        cargoIncLimitError: error.cargo_Inc_limit || [],
        liabilityIncLimitError: error.liability_Inc_limit || [],
        cargoIncAgentError: error.cargo_Inc_agent || [],
        agentPhoneError: error.agent_phone || [],
        IncDeductibleError: error.Inc_deductible || [],
        drivingLicenceError: error.driving_licence || [],
        profileFileError: error.profile_picture || [],
        generalError: error.general || [],
        shipperTypeError: error.shipper_type || [],
      };
  
      setAllError((prevErrors) => ({
        ...prevErrors,
        ...errorFields,
      }));
  
      window.scrollTo(0, 100);
    }
  }, [error]);
  
  useEffect(() => {
    dispatch(progressing_status(isLoading));
  }, [isLoading, dispatch]);

  // image cropping start =============================================
  const [croppingModal, setCroppingModal] = useState(false);
  const [profilePictureDefaultUrl, setProfilePictureDefaultUrl] =
    useState(false);
  const [croppedImg, setCroppedImg] = useState(false);
  const imgRef = React.useRef(null);
  const canvas_ref = React.useRef(undefined);

  const [isCropped, setIsCropped] = useState(false);

  const [crop, setCrop] = useState({
    unit: "%",
    width: 90,
    height: 66.67,
    x: 5,
    y: 17,
  });

  const crop_size = () => {
    if (imgRef.current) {
      let { width, height } = imgRef.current;
      let crop_option = centerCrop(
        makeAspectCrop(
          {
            unit: "%",
            width: 90,
          },
          27 / 20,
          width,
          height
        ),
        width,
        height
      );
      setCrop(crop_option);

      setAllValues({
        ...allValues,
        profile_image_screen_width: width,
        profile_image_screen_height: height,
      });
    }
  };

  const imageCroppingModalOpen = () => {
    setCroppingModal(true);
  };

  const imageCroppingModalClose = () => {
    setCroppingModal(false);
    !isCropped && crop_size();
  };

  const get_image_blob_data = (e) => {
    try {
      let reader = new FileReader();
      reader.onload = function (el) {
        setProfilePictureDefaultUrl(el.target.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    } catch {}
  };
  // image cropping end =============================================
  useEffect(() => {
    crop_size();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgRef.current]);

  const imageCropComplete = (crop) => {
    !isCropped && setIsCropped(true);

    setAllValues({
      ...allValues,
      profile_image_x: crop.x,
      profile_image_y: crop.y,
      profile_image_width: crop.width,
      profile_image_height: crop.height,
    });

    let image = imgRef.current;
    if (!canvas_ref.current) return;
    const imageCanvas = canvas_ref.current;

    let scale = 1;
    let rotate = 0;
    const TO_RADIANS = Math.PI / 180;
    const ctx = imageCanvas.getContext("2d");

    if (!ctx) return;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const pixelRatio = window.devicePixelRatio;
    // const pixelRatio = 1

    imageCanvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    imageCanvas.height = Math.floor(crop.height * scaleY * pixelRatio);

    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = "high";

    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;

    const rotateRads = rotate * TO_RADIANS;
    const centerX = image.naturalWidth / 2;
    const centerY = image.naturalHeight / 2;

    ctx.save();

    ctx.translate(-cropX, -cropY);

    ctx.translate(centerX, centerY);

    ctx.rotate(rotateRads);

    ctx.scale(scale, scale);

    ctx.translate(-centerX, -centerY);

    ctx.drawImage(
      image,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight
    );

    ctx.restore();

    try {
      imageCanvas.toBlob((blob) => {
        const url = URL.createObjectURL(blob);
        setCroppedImg(url);
      });
    } catch (error) {}
  };

  // for cancle button  
  const handleCancel = () => {
    navigate(-1); // Go back to the previous page
  }

  return (
    <div className="col-lg-8">
      {successMessage !== "" ? (
        <Alert severity="success" className="mb-5">
          <AlertTitle>Success</AlertTitle>
          <strong>{successMessage}</strong>
        </Alert>
      ) : (
        ''
      )}

      {/* {allError.generalError != "" && (
        <Alert severity="error" className="mb-5">
          <AlertTitle>Error (test)</AlertTitle>
          <strong>{allError.generalError}</strong>
        </Alert>
      )} */}

      {allError.generalError?.length > 0 && (
        <Alert severity="error" className="mb-5">
          <AlertTitle>Error</AlertTitle>
          <strong>{allError.generalError}</strong>
        </Alert>
      )}


      {allError.messageError?.length > 0 && (
        <Alert severity="error">
          <strong>{allError.messageError}</strong>
        </Alert>
      )}

      <div className="user-image-update">
        {croppedImg ? (
          <img src={croppedImg} alt="img" />
        ) : (
          <img
            src={allValues.profile_url ? allValues.profile_url : avatar}
            alt="img"
          />
        )}

        <input
          type="file"
          name="profile_picture"
          onChange={(e) => {
            handleInputChange(e);
            get_image_blob_data(e);
            imageCroppingModalOpen();
          }}
        />
        <i className="fa-solid fa-camera"></i>
      </div>

      <canvas className="d-none" ref={canvas_ref}>
        {" "}
      </canvas>

      <Modal
        open={croppingModal}
        onClose={imageCroppingModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="user-sign-up-img-cropper-area"
      >
        <div className="user-sign-up-img-modal">
          {profilePictureDefaultUrl && (
            <ReactCrop
              crop={crop}
              onChange={(c) => setCrop(c)}
              onComplete={imageCropComplete}
              aspect={27 / 20}
              minWidth={60}
              keepSelection={true}
            >
              <img
                ref={imgRef}
                src={profilePictureDefaultUrl}
                id="profile-image-cropping"
                alt="img"
                style={{
                  maxWidth: `${window.innerWidth - 20}px`,
                  maxHeight: `${window.innerHeight - 300}px`,
                }}
              />
            </ReactCrop>
          )}
          <Button
            className="theme-btn auth-image-resize-confirm-btn"
            onClick={imageCroppingModalClose}
          >
            Upload
          </Button>
        </div>
      </Modal>

      <div className="row">
        {allError.profileFileError?.map((error, index) => (
          <Alert severity="error" key={shortid.generate()}>
            <strong>{error}</strong>
          </Alert>
        ))}
      </div>

      <div className="row user-editable-inputs">
        <div className="col-lg-6">
          <div className="input-box-area" single-labe="true">
            <label> First Name</label>
            <input
              type="text"
              name="first_name"
              placeholder="First Name"
              value={allValues.first_name}
              onChange={handleInputChange}
              onClick={hideErrorMessage}
            />
            <div className="error" show-tittle="true">
              {allError.firstNameError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.firstNameError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="input-box-area" single-labe="true">
            <label> Last Name</label>
            <input
              type="text"
              name="last_name"
              onChange={handleInputChange}
              placeholder="Last Name"
              value={allValues.last_name}
              onClick={hideErrorMessage}
            />
            <div className="error" show-tittle="true">
              {allError.lastNameError.length > 0 && (
                <div>
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              )}
              {allError.lastNameError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="input-box-area" single-labe="true">
            <label> Email</label>
            <input
              type="text"
              name="email"
              placeholder="Email"
              value={allValues.email}
              onChange={handleInputChange}
              onClick={hideErrorMessage}
            />
            <div className="error" show-tittle="true">
              {allError.emailError.length > 0 && (
                <div>
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              )}
              {allError.emailError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="input-box-area" single-labe="true">
            <label> Phone</label>

            <div className="phone-number-input-area">
              <input
                type="text"
                defaultValue="+1"
                disabled="true"
                className="phone-number-input-code"
              />
              <input
                type="text"
                name="phone_number"
                placeholder="e.g. 6505552671"
                value={allValues.phone_number}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
            </div>

            <div className="error" show-tittle="true">
              {allError.phoneNumberError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
               ''
              )}
              {allError.phoneNumberError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="input-box-area" single-labe="true">
            <label> Street Address </label>
            <input
              type="text"
              name="street_address"
              value={allValues.street_address}
              onChange={handleInputChange}
              onClick={hideErrorMessage}
            />
            <div className="error" show-tittle="true">
              {allError.streetAddressError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.streetAddressError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="input-box-area" single-labe="true">
            <label>Country</label>
            <div>
              <Select
                value={allValues.country}
                label="Country"
                name="country"
                onChange={handleInputChange}
                className="input-box-area-select-field mui-select-field-without-label"
                id="country-input-field"
                fullWidth
                onClick={hideErrorMessage}
              >
                {countryList?.map((country, index) => (
                  <MenuItem value={country} key={shortid.generate()}>
                    {country}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="error" show-tittle="true">
              {allError.stateError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.stateError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="input-box-area" single-labe="true">
            <label> State/Region</label>
            <div>
              <Select
                value={allValues.state}
                label="State"
                name="state"
                onChange={handleInputChange}
                className="input-box-area-select-field mui-select-field-without-label"
                id="state-input-field"
                fullWidth
                onClick={hideErrorMessage}
              >
                {stateList?.map((state, index) => (
                  <MenuItem value={state} key={shortid.generate()}>
                    {state}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="error" show-tittle="true">
              {allError.stateError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.stateError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="input-box-area" single-labe="true">
            <label> City</label>
            <div>
              <Select
                value={allValues.city}
                label="City"
                name="city"
                onChange={handleInputChange}
                className="input-box-area-select-field mui-select-field-without-label"
                fullWidth
                onClick={hideErrorMessage}
              >
                {cityList?.map((state, index) => (
                  <MenuItem value={state} key={shortid.generate()}>
                    {state}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="error" show-tittle="true">
              {allError.cityError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.cityError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="input-box-area" single-labe="true">
            <label> Zip Code </label>
            <input
              type="text"
              name="zip_code"
              value={allValues.zip_code}
              onChange={handleInputChange}
              onClick={hideErrorMessage}
            />
            <div className="error" show-tittle="true">
              {allError.zipCodeError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.zipCodeError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="row user-editable-inputs">
        <div className="col-lg-6">
          <div className="input-box-area" single-labe="true">
            <label> Bank Account Holder Name</label>
            <input
              type="text"
              name="bank_account_holder_name"
              value={allValues.bank_account_holder_name}
              onChange={handleInputChange}
              onClick={hideErrorMessage}
            />
            <div className="error" show-tittle="true">
              {allError.bankAccountHolderNameError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.bankAccountHolderNameError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="input-box-area" single-labe="true">
            <label> Bank Account Number</label>
            <input
              type="text"
              name="bank_account_number"
              value={allValues.bank_account_number}
              onChange={handleInputChange}
              onClick={hideErrorMessage}
            />
            <div className="error" show-tittle="true">
              {allError.bankAccountNumberError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.bankAccountNumberError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="input-box-area" single-labe="true">
            <label> Bank Name</label>
            <input
              type="text"
              name="bank_name"
              value={allValues.bank_name}
              onChange={handleInputChange}
              onClick={hideErrorMessage}
            />
            <div className="error" show-tittle="true">
              {allError.bankNameError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.bankNameError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="input-box-area" single-labe="true">
            <label> Bank Branch Name</label>
            <input
              type="text"
              name="bank_account_branch_name"
              value={allValues.bank_account_branch_name}
              onChange={handleInputChange}
              onClick={hideErrorMessage}
            />
            <div className="error" show-tittle="true">
              {allError.bankAccountBranchNameError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.bankAccountBranchNameError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="input-box-area" single-labe="true">
            <label> Bank Account Country</label>
            <input
              type="text"
              name="bank_account_country"
              value={allValues.bank_account_country}
              onChange={handleInputChange}
              onClick={hideErrorMessage}
            />
            <div className="error" show-tittle="true">
              {allError.bankAccountCountryError.length > 0 ? (
                <div>
                  {" "}
                  <i className="fa-solid fa-circle-exclamation"></i>{" "}
                </div>
              ) : (
                ''
              )}
              {allError.bankAccountCountryError?.map((error, index) => (
                <div key={shortid.generate()}>
                  <p className="auth-error" key={index}>
                    {error}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {userData?.user_type === "shipper" ? (
        <div className="row user-editable-inputs border-0">
          <div className="col-lg-6">
            <div className="input-box-area" single-labe="true">
              <label>Company Name</label>
              <input
                type="text"
                name="company_name"
                value={allValues.company_name}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.companyNameError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.companyNameError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-box-area" single-labe="true">
              <label> Shipper Type :</label>
              <div>
                <Select
                  label="Load Type"
                  name="shipper_type"
                  value={allValues.shipper_type}
                  onChange={handleInputChange}
                  className="input-box-area-select-field mui-select-field-without-label"
                  fullWidth
                >
                  <MenuItem value="brokers">Brokers</MenuItem>
                  <MenuItem value="shipper">Shipper</MenuItem>
                  <MenuItem value="small_businesses">Small Businesses</MenuItem>
                  <MenuItem value="big_businesses">Big Businesses</MenuItem>
                </Select>
              </div>
              <div className="error" show-tittle="true">
                {allError.shipperTypeError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.shipperTypeError?.map((error, index) => (
                  <div>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-box-area" single-labe="true">
              <label>Bonding Agent </label>
              <input
                type="text"
                name="bonding_agent"
                value={allValues.bonding_agent}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.bondingAgentError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.bondingAgentError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="input-box-area" single-labe="true">
              <label>Licence Number</label>
              <input
                type="text"
                name="license_number"
                value={allValues.license_number}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.licenseNumberError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.licenseNumberError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-box-area" single-labe="true">
              <label>Bonding Co. Phone Number</label>

              <div className="phone-number-input-area">
                <input
                  type="text"
                  defaultValue="+1"
                  disabled="true"
                  className="phone-number-input-code"
                />
                <input
                  type="text"
                  name="bonding_co_phone_number"
                  value={allValues.bonding_co_phone_number}
                  onChange={handleInputChange}
                  onClick={hideErrorMessage}
                />
              </div>
              <div className="error" show-tittle="true">
                {allError.bondingCoPhoneNumberError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.bondingCoPhoneNumberError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="row user-editable-inputs">
          <div className="col-lg-6">
            <div className="input-box-area" single-labe="true">
              <label> Company Name</label>
              <input
                type="text"
                value={allValues.company_name}
                name="company_name"
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.companyNameError.length > 0 ? (
                  <div>
                    <i className="fa-solid fa-circle-exclamation"></i>
                  </div>
                ) : (
                 ''
                )}
                {allError.companyNameError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-box-area" single-labe="true">
              <label> Carrier Types</label>
              <div>
                <Select
                  value={allValues.carrier_type}
                  label="Load Type"
                  name="carrier_type"
                  onChange={handleInputChange}
                  className="input-box-area-select-field mui-select-field-without-label"
                  fullWidth
                >
                  <MenuItem value="single_carrier">Single Carrier</MenuItem>
                  <MenuItem value="delivery_company">Delivery Company</MenuItem>
                </Select>
              </div>
              <div className="error" show-tittle="true">
                {allError.carrierTypeError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.carrierTypeError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="input-box-area" single-labe="true">
              <label> Load Types</label>
              <div>
                <Select
                  value={allValues.load_type}
                  label="Load Type"
                  name="load_type"
                  onChange={handleInputChange}
                  className="input-box-area-select-field mui-select-field-without-label"
                  fullWidth
                >
                  <MenuItem value="pallet">Pallet</MenuItem>
                  <MenuItem value="vehicle">Vehicle</MenuItem>
                  <MenuItem value="barrel">Barrel</MenuItem>
                  <MenuItem value="stones">Stones</MenuItem>
                  <MenuItem value="sand">Sand</MenuItem>
                  <MenuItem value="laterite">Laterite</MenuItem>
                </Select>
              </div>
              <div className="error" show-tittle="true">
                {allError.loadTypeError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.loadTypeError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="input-box-area" single-labe="true">
              <label> Cargo Insurance Company</label>
              <input
                type="text"
                placeholder="Cargo Insurance Company"
                name="cargo_insurance_company"
                value={allValues.cargo_insurance_company || ""}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.cargoInsuranceCompanyError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.cargoInsuranceCompanyError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-box-area" single-labe="true">
              <label> Cargo Ins. Limit</label>
              <input
                type="text"
                name="cargo_Inc_limit"
                value={allValues.cargo_Inc_limit}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.cargoIncLimitError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.cargoIncLimitError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="input-box-area" single-labe="true">
              <label> Liability Ins. Limit</label>
              <input
                type="text"
                name="liability_Inc_limit"
                value={allValues.liability_Inc_limit}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.liabilityIncLimitError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.liabilityIncLimitError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-box-area" single-labe="true">
              <label> ICC MC Numbers</label>
              <input
                type="text"
                placeholder="ICC MC Numbers"
                name="icc_mc_number"
                value={allValues.icc_mc_number}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.iccMcNumberError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.iccMcNumberError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-box-area" single-labe="true">
              <label> Agent Phone</label>
              <div className="phone-number-input-area">
                <input
                  type="text"
                  defaultValue="+1"
                  disabled="true"
                  className="phone-number-input-code"
                />
                <input
                  type="text"
                  placeholder="Agent Phone"
                  name="agent_phone"
                  value={allValues.agent_phone}
                  onChange={handleInputChange}
                  onClick={hideErrorMessage}
                />
              </div>
              <div className="error" show-tittle="true">
                {allError.agentPhoneError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.agentPhoneError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-box-area" single-labe="true">
              <label> Ins. Deductible</label>
              <input
                type="text"
                placeholder="Ins. Deductible"
                name="Inc_deductible"
                value={allValues.Inc_deductible}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.IncDeductibleError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.IncDeductibleError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-box-area" single-labe="true">
              <label> Cargo Ins. Agent</label>
              <input
                type="text"
                placeholder="Cargo Ins. Agent"
                name="cargo_Inc_agent"
                value={allValues.cargo_Inc_agent}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.cargoIncAgentError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.cargoIncAgentError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-box-area" single-labe="true">
              <label> Driving Licence</label>
              <input
                type="text"
                placeholder="Cargo Ins. Agent"
                name="driving_licence"
                value={allValues.driving_licence}
                onChange={handleInputChange}
                onClick={hideErrorMessage}
              />
              <div className="error" show-tittle="true">
                {allError.drivingLicenceError.length > 0 ? (
                  <div>
                    {" "}
                    <i className="fa-solid fa-circle-exclamation"></i>{" "}
                  </div>
                ) : (
                  ''
                )}
                {allError.drivingLicenceError?.map((error, index) => (
                  <div key={shortid.generate()}>
                    <p className="auth-error" key={index}>
                      {error}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="input-box-area" single-labe="true">
              <label>Vehicle Image</label>
            </div>

            <div className="user-image-update" style={{ width: "100%" }}>
              <img
                src={
                  allValues.vehicle_image_url
                    ? allValues.vehicle_image_url
                    : avatar
                }
                alt="img"
              />

              <input
                type="file"
                name="vehicle_image"
                onChange={(e) => {
                  handleInputChange(e);
                }}
              />
              <i className="fa-solid fa-camera"></i>
            </div>
          </div>
        </div>
      )}

      <div className="multiple-btn update-reset-btn justify-content-center flex-wrap">

        <Button className="mx-1" onClick={handleSubmit}>
          <i className="fa-solid fa-floppy-disk"></i>
          Update Profile
          {isLoading && (
            <SpinnerCircular
              size={22}
              thickness={180}
              speed={130}
              color="#fff"
              className="btn-loader"
              secondaryColor="rgba(57, 172, 127, 0.44)"
            />
          )}
        </Button>

        <Button className="mx-1" onClick={handleCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default ProfileInformation;
